import fetch from '../utils/fetch';
import * as M from './__model';
export class LoginController {

    /**
      * 校验申请是否存在 
      */ 
    public static applicationExist(request: M.AccountVerifyRequest ) {
      return fetch.get<M.AccountExistResponse>('/account/applicationExist', { params:request});
    }

    /**
      * 登录接口 
      */ 
    public static login(request: M.LoginRequest ) {
      return fetch.post<M.LoginResponse>('/account/login',request);
    }

    /**
      * 登出接口 
      */ 
    public static logout() {
      return fetch.get<void>('/account/logout');
    }

    /**
      * 发送验证码 
      */ 
    public static sendVerifyCode(mobile: string ,areaCode: string ) {
      return fetch.get<void>('/account/vcodeSend', { params:{mobile,areaCode}});
    }

    /**
      * 校验验证码 
      */ 
    public static verifyVCode(areaCode: string ,mobile: string ,vcode: string ) {
      return fetch.get<void>('/account/vcodeVerify', { params:{areaCode,mobile,vcode}});
    }


}
export class WuxiApplicationController {

    /**
      * 新增申请 
      */ 
    public static addApplication(request: M.WuxiApplicationRequest ) {
      return fetch.post<void>('/wuxi/application/add',request);
    }

    /**
      * 保存草稿 
      */ 
    public static addDraft(request: M.WuxiApplicationDraftRequest ) {
      return fetch.post<void>('/wuxi/application/addDraft',request);
    }

    /**
      * 根据id查询申请详情 
      */ 
    public static getApplicationById(studentId: number ) {
      return fetch.get<M.WuxiApplicationResponse>('/wuxi/application/detail', { params:{studentId}});
    }

    /**
      * 获取草稿 
      */ 
    public static getDraft(draftId: string ) {
      return fetch.get<M.WuxiApplicationResponse>('/wuxi/application/getDraft', { params:{draftId}});
    }

    /**
      * 更新家长信息 
      */ 
    public static updateParent(request: M.WuxiUpdateParentRequest ) {
      return fetch.put<void>('/wuxi/application/updateParent',request);
    }

    /**
      * 更新学生信息 
      */ 
    public static updateStudent(request: M.WuxiApplicationStudentRequest ) {
      return fetch.put<void>('/wuxi/application/updateStudent',request);
    }


}
export class ApplicationListController {

    /**
      * 获取学生清单详情 
      */ 
    public static getApplicationListDetailList(studentId: number ) {
      return fetch.get<M.ApplicationListDetailResponse[]>('/applicationList/applicationListDetailList', { params:{studentId}});
    }

    /**
      * 获取未完成申请清单列表 
      */ 
    public static getUnfinishedApplicationListList() {
      return fetch.get<M.UnfinishedApplicationListInfoResponse[]>('/applicationList/unfinishedApplicationListList');
    }

    /**
      * 上传清单 
      */ 
    public static uploadApplicationListInfo(applicationResourceRequest: M.ApplicationResourceRequest ) {
      return fetch.post<void>('/applicationList/uploadApplicationListInfo',applicationResourceRequest);
    }


}
export class OrderController {

    /**
      * 获取学生订单详情列表 
      */ 
    public static getDetailsByStudentId(studentId: number ) {
      return fetch.get<M.OrderDetailResponse[]>('/order/studentOrderDetail', { params:{studentId}});
    }


}
export class KunshanApplicationController {

    /**
      * 新增申请 
      */ 
    public static addApplication(request: M.KunshanApplicationRequest ) {
      return fetch.post<void>('/kunshan/application/add',request);
    }

    /**
      * 保存草稿 
      */ 
    public static addDraft(request: M.KunshanApplicationDraftRequest ) {
      return fetch.post<void>('/kunshan/application/addDraft',request);
    }

    /**
      * 根据id查询申请详情 
      */ 
    public static getApplicationById(studentId: number ) {
      return fetch.get<M.KunshanApplicationResponse>('/kunshan/application/detail', { params:{studentId}});
    }

    /**
      * 获取草稿 
      */ 
    public static getDraft(draftId: string ) {
      return fetch.get<M.KunshanApplicationResponse>('/kunshan/application/getDraft', { params:{draftId}});
    }

    /**
      * 汉字转拼音 
      */ 
    public static nameConvertSpell(name: string ) {
      return fetch.get<any>('/kunshan/application/toPinyin', { params:{name}});
    }

    /**
      * 更新家长信息 
      */ 
    public static updateParent(request: M.KunshanUpdateParentRequest ) {
      return fetch.put<void>('/kunshan/application/updateParent',request);
    }

    /**
      * 更新学生信息 
      */ 
    public static updateStudent(request: M.KunshanApplicationStudentRequest ) {
      return fetch.put<void>('/kunshan/application/updateStudent',request);
    }


}
export class BaseApplicationController {

    /**
      * 添加中信银行卡信息 
      */ 
    public static addCiticBankInfo(request: M.CiticBankRequest ) {
      return fetch.put<void>('/application/addCiticBankInfo',request);
    }

    /**
      * 查询申请列表 
      */ 
    public static getApplicationList() {
      return fetch.get<M.ApplicationBriefResponse[]>('/application/list');
    }

    /**
      * 根据学年和生日获取推荐年级 
      */ 
    public static getCommendSectionAndCampus(schoolYearId: number ,birthday: number ,countryId: number ) {
      return fetch.get<M.SectionCampusResponse>('/application/commentSection', { params:{schoolYearId,birthday,countryId}});
    }

    /**
      * 根据学生id查询关联家长信息 
      */ 
    public static getRelatedParent(studentId?: number ) {
      return fetch.get<M.ParentResponse>('/application/relatedParent', { params:{studentId}});
    }

    /**
      * 根据手机号查询所有关联学生列表 
      */ 
    public static getRelatedStudents(areaCode: string ,mobile: string ) {
      return fetch.get<M.ApplicationResponse[]>('/application/relatedStudents', { params:{areaCode,mobile}});
    }

    /**
      * 年级出生日期对应列表 
      */ 
    public static getSectionDate() {
      return fetch.get<M.SectionDateResponse>('/application/sectionDateList');
    }

    /**
      * 根据家长查询已存在的兄弟姐妹 
      */ 
    public static getSibLingsByParent() {
      return fetch.get<M.SiblingResponse[]>('/application/siblings');
    }

    /**
      * 判断申请的学生是不是已存在 
      */ 
    public static validStudentExist(idType: number ,idNumber: string ) {
      return fetch.get<M.StudentExistResponse>('/application/studentExist', { params:{idType,idNumber}});
    }


}
export class WechatController {

    /**
      * 获取accessToken 
      */ 
    public static getAccessToken(code: string ) {
      return fetch.get<M.WechatAccessTokenResponse>('/wechat/accessToken', { params:{code}});
    }

    /**
      * 获取公众号签名 
      */ 
    public static getSgin(url: string ) {
      return fetch.get<M.WechaSignResponse>('/wechat/sign', { params:{url}});
    }


}
export class MessageController {

    /**
      * 获取当前学生可发送消息的教师列表 
      */ 
    public static getInviteMemberList(studentId: number ) {
      return fetch.get<M.MemberResponse[]>('/message/inviteMemberList', { params:{studentId}});
    }

    /**
      * 获取最近收到的消息列表 
      */ 
    public static getLatestReceiveMessageList(messageNum?: number ) {
      return fetch.get<M.MessageResponse[]>('/message/latestReceiveMessageList', { params:{messageNum}});
    }

    /**
      * 获取接收消息详情 
      */ 
    public static getReceiveMessageDetail(messageId: number ) {
      return fetch.get<M.MessageResponse[]>('/message/receiveMessageDetail', { params:{messageId}});
    }

    /**
      * 获取我收到的消息列表 
      */ 
    public static getReceiveMessageList(studentId: number ,pageCurrent: number ,pageSize: number ) {
      return fetch.get<M.PagedList<M.MessageResponse>>('/message/messageReceiveList', { params:{studentId,pageCurrent,pageSize}});
    }

    /**
      * 获取我的批量发送消息列表 
      */ 
    public static getSendMessageBatchList(studentId: number ,pageCurrent: number ,pageSize: number ) {
      return fetch.get<M.PagedList<M.MessageBatchListResponse>>('/message/messageSendList', { params:{studentId,pageCurrent,pageSize}});
    }

    /**
      * 获取发送消息详情 
      */ 
    public static getSendMessageDetail(messageBatchId: number ) {
      return fetch.get<M.MessageResponse[]>('/message/sendMessageDetail', { params:{messageBatchId}});
    }

    /**
      * 获取未读消息列表 
      */ 
    public static getUnreadMessageList() {
      return fetch.get<M.UnreadMessageResponse[]>('/message/unreadMessageList');
    }

    /**
      * 答复消息 
      */ 
    public static replyMessageBatch(batchMessageReplyRequest: M.BatchMessageReplyRequest ) {
      return fetch.post<void>('/message/replyMessageBatch',batchMessageReplyRequest);
    }

    /**
      * 发消息 
      */ 
    public static sentMessageBatch(batchMessageRequest: M.BatchMessageRequest ) {
      return fetch.post<void>('/message/sentMessageBatch',batchMessageRequest);
    }

    /**
      * 修改阅读状态 
      */ 
    public static updateReadFlag(messageId: number ) {
      return fetch.put<void>('/message/updateReadFlag', {}, { params:{messageId}});
    }


}
export class ConsultController {

    /**
      * 添加咨询信息 
      */ 
    public static addConsult(request: M.ConsultRequest ) {
      return fetch.post<number>('/consult/addConsult',request);
    }

    /**
      * 查询咨询列表 
      */ 
    public static getConsultList(studentId: number ) {
      return fetch.get<M.ConsultResponse[]>('/consult/list', { params:{studentId}});
    }

    /**
      * 根据手机获取最新的咨询 
      */ 
    public static getRelateConsults(mobile: string ) {
      return fetch.get<M.ConsultResponse[]>('/consult/relateConsults', { params:{mobile}});
    }

    /**
      * 更新咨询参加状态 
      */ 
    public static signIn(activityId: number ,mobile: string ) {
      return fetch.put<M.ConsultMasterSignResponse>('/consult/signIn', {}, { params:{activityId,mobile}});
    }


}
export class ActivityController {

    /**
      * 查询活动详情 
      */ 
    public static getActivityDetail(activityId: number ) {
      return fetch.get<M.ActivityResponse>('/activity/detail', { params:{activityId}});
    }

    /**
      * 根据活动渠道关联id获取活动信息 
      */ 
    public static getActivityInfoByActivityChannelId(activityChannelId: number ) {
      return fetch.get<M.ActivityChannelResponse>('/activity/getActivityInfoByActivityChannelId', { params:{activityChannelId}});
    }


}
export class SchoolUniformController {

    /**
      * 获取申请人校服信息 
      */ 
    public static getApplicationSchoolUniform(studentId: number ) {
      return fetch.get<M.ApplicationSchoolUniformResponse>('/schoolUniform/applicationSchoolUniform', { params:{studentId}});
    }

    /**
      * 获取当前家长下校服信息的申请人列表 
      */ 
    public static getApplicationSchoolUniformListByParent() {
      return fetch.get<M.ApplicationSchoolUniformResponse[]>('/schoolUniform/parentApplicationSchoolUniformList');
    }

    /**
      * 获取校服收款方信息 
      */ 
    public static getSchoolUniformPayeeInfo() {
      return fetch.get<M.SchoolUniformPayeeResponse>('/schoolUniform/schoolUniformPayeeInfo');
    }

    /**
      * 修改申请人校服信息 
      */ 
    public static modifyApplicationSchoolUniform(request: M.ApplicationSchoolUniformRequest ) {
      return fetch.put<void>('/schoolUniform/modifyApplicationSchoolUniform',request);
    }


}
export class DropDownController {

    /**
      * 查询学历下拉列表 
      */ 
    public static getAcademicQualificationList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/academicQualificationList');
    }

    /**
      * 查询探校时间列表 
      */ 
    public static getActivityVisitList(activityChannelId: number ,sectionId?: number ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/activityVisitList', { params:{activityChannelId,sectionId}});
    }

    /**
      * 查询校区下拉列表 
      */ 
    public static getCampusList() {
      return fetch.get<M.CampusDropDownResponse[]>('/dropDown/campusList');
    }

    /**
      * 根据省份查询城市列表 
      */ 
    public static getCityByProvince(provinceCode: string ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/cityByProvince', { params:{provinceCode}});
    }

    /**
      * 查询城市下拉列表 
      */ 
    public static getCityList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/cityList');
    }

    /**
      * 查询咨询学年和学期下拉列表 
      */ 
    public static getConsultSchoolYearAndSemesterList(excludeDisable?: boolean ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/consultSchoolYearAndSemesterList', { params:{excludeDisable}});
    }

    /**
      * 查询咨询年级下拉列表 
      */ 
    public static getConsultSectionList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/consultSectionList');
    }

    /**
      * 查询国籍下拉列表 
      */ 
    public static getCountryList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/countryList');
    }

    /**
      * 查询国家或地区码下拉列表 
      */ 
    public static getCountryWithCodeList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/countryWithCodeList');
    }

    /**
      * 根据城市查询区列表 
      */ 
    public static getDistrictByCity(cityCode: string ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/districtByCity', { params:{cityCode}});
    }

    /**
      * 查询英文水平下拉列表 
      */ 
    public static getEnglishList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/englishList');
    }

    /**
      * 查询证件类型下拉列表 
      */ 
    public static getIdTypeList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/idTypeList');
    }

    /**
      * 查询主要使用语言下拉列表 
      */ 
    public static getMainLanguageList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/mainLanguageList');
    }

    /**
      * 查询学生家长关系下拉列表 
      */ 
    public static getMemberShipList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/membershipList');
    }

    /**
      * 根据名称查询员工 
      */ 
    public static getMembersByName(name: string ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/membersByName', { params:{name}});
    }

    /**
      * 查询省份下拉列表 
      */ 
    public static getProvinceList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/provinceList');
    }

    /**
      * 查询学校库下拉列表 
      */ 
    public static getSchoolLibList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/schoolLibList');
    }

    /**
      * 查询校服尺寸下拉列表 
      */ 
    public static getSchoolUniformSizeList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/schoolUniformSizeList');
    }

    /**
      * 查询学年和学期下拉列表 
      */ 
    public static getSchoolYearAndSemesterList(excludeDisable?: boolean ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/schoolYearAndSemesterList', { params:{excludeDisable}});
    }

    /**
      * 查询学年下拉列表 
      */ 
    public static getSchoolYearList(excludeDisable?: boolean ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/schoolYearList', { params:{excludeDisable}});
    }

    /**
      * 查询年级下拉列表 
      */ 
    public static getSectionList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/sectionList');
    }

    /**
      * 查询推荐来源下拉列表 
      */ 
    public static getSourceList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/sourceList');
    }

    /**
      * 查询学生类型下拉列表 
      */ 
    public static getStudentTypeList() {
      return fetch.get<M.DropDownResponse[]>('/dropDown/studentTypeList');
    }

    /**
      * 根据名称查询学生 
      */ 
    public static getStudentsByName(name: string ) {
      return fetch.get<M.DropDownResponse[]>('/dropDown/studentsByName', { params:{name}});
    }


}
export class PDFController {

    /**
      * 导出 
      */ 
    public static export(studentId: number ,schoolId: number ,token: string ,includeOptRecordFlag?: boolean ,englishFlag?: boolean ) {
      return fetch.get<void>('/pdf/export', { params:{studentId,schoolId,token,includeOptRecordFlag,englishFlag}});
    }


}
export class AccessLogController {

    /**
      * 添加访问日志 
      */ 
    public static addAccessLog(request: M.AccessLogRequest ) {
      return fetch.post<void>('/accessLog/addAccessLog',request);
    }


}
export class CommonController {

    /**
      * 得到七牛Token 
      */ 
    public static getQiniuEtcToken() {
      return fetch.get<M.TokenResponse>('/common/qiniuToken');
    }


}
export class PersonalCenterController {

    /**
      * 根据主键查询个人信息 
      */ 
    public static getParentInfoById() {
      return fetch.get<M.ParentResponse>('/personalCenter/parentInfo');
    }

    /**
      * 修改账号信息 
      */ 
    public static updateAccount(newMobile: string ,vCode: string ,areaCode: string ) {
      return fetch.put<M.TokenResponse>('/personalCenter/updateAccount', {}, { params:{newMobile,vCode,areaCode}});
    }

    /**
      * 根据主键修改个人信息 
      */ 
    public static updatePersonalInfo(request: M.ParentInfoRequest ) {
      return fetch.put<void>('/personalCenter/updatePersonalInfo',request);
    }


}
export class CourseCenterApplicationController {

    /**
      * 新增申请 
      */ 
    public static addApplication(request: M.CourseCenterApplicationRequest ) {
      return fetch.post<void>('/courseCenter/application/add',request);
    }

    /**
      * 保存草稿 
      */ 
    public static addDraft(request: M.CourseCenterApplicationDraftRequest ) {
      return fetch.post<void>('/courseCenter/application/addDraft',request);
    }

    /**
      * 根据id查询申请详情 
      */ 
    public static getApplicationById(studentId: number ) {
      return fetch.get<M.CourseCenterApplicationResponse>('/courseCenter/application/detail', { params:{studentId}});
    }

    /**
      * 获取草稿 
      */ 
    public static getDraft(draftId: string ) {
      return fetch.get<M.CourseCenterApplicationResponse>('/courseCenter/application/getDraft', { params:{draftId}});
    }

    /**
      * 获取考试成绩 
      */ 
    public static getExamResultDetail(studentId: number ) {
      return fetch.get<M.ExamResultResponse>('/courseCenter/application/examResultDetail', { params:{studentId}});
    }

    /**
      * 更新考试成绩 
      */ 
    public static updateExamResult(examResultRequest: M.ExamResultRequest ) {
      return fetch.put<void>('/courseCenter/application/updateExamResult',examResultRequest);
    }

    /**
      * 更新学生信息 
      */ 
    public static updateStudent(request: M.CourseCenterApplicationStudentRequest ) {
      return fetch.put<void>('/courseCenter/application/updateStudent',request);
    }


}
export class SchoolController {

    /**
      * 查询所有学校列表 
      */ 
    public static getAllSchools() {
      return fetch.get<M.SchoolBriefInfoResponse[]>('/school/all');
    }

    /**
      * 查询所有学校列表 
      */ 
    public static getSchoolsByParent() {
      return fetch.get<M.SchoolBriefInfoResponse[]>('/school/own');
    }


}
export class FormFieldController {

    /**
      * 获取活动表单字段列表 
      */ 
    public static getActivityFormFieldList(activityId: number ) {
      return fetch.get<M.FormFieldResponse[]>('/formField/actFormFieldList', { params:{activityId}});
    }


}
export class PolyvController {

    /**
      * 提供给保利威的认证接口 
      */ 
    public static auth(request: M.PolyvAuthRequest ) {
      return fetch.get<M.PolyvAuthResponse>('/polyv/auth', { params:request});
    }

    /**
      * 同步保利威直播信息 
      */ 
    public static synchronizeLiveChannel(activityChannelId: number ) {
      return fetch.post<void>('/polyv/synchronizeLiveChannel', {}, { params:{activityChannelId}});
    }

    /**
      * 同步保利威直播信息 
      */ 
    public static task() {
      return fetch.get<void>('/polyv/task');
    }


}
export class HangzhouApplicationController {

    /**
      * 新增申请 
      */ 
    public static addApplication(request: M.HangzhouApplicationRequest ) {
      return fetch.post<void>('/Hangzhou/application/add',request);
    }

    /**
      * 保存草稿 
      */ 
    public static addDraft(request: M.HangzhouApplicationDraftRequest ) {
      return fetch.post<void>('/Hangzhou/application/addDraft',request);
    }

    /**
      * 根据id查询申请详情 
      */ 
    public static getApplicationById(studentId: number ) {
      return fetch.get<M.HangzhouApplicationResponse>('/Hangzhou/application/detail', { params:{studentId}});
    }

    /**
      * 获取草稿 
      */ 
    public static getDraft(draftId: string ) {
      return fetch.get<M.HangzhouApplicationResponse>('/Hangzhou/application/getDraft', { params:{draftId}});
    }

    /**
      * 更新家长信息 
      */ 
    public static updateParent(request: M.HangzhouUpdateParentRequest ) {
      return fetch.put<void>('/Hangzhou/application/updateParent',request);
    }

    /**
      * 更新学生信息 
      */ 
    public static updateStudent(request: M.HangzhouApplicationStudentRequest ) {
      return fetch.put<void>('/Hangzhou/application/updateStudent',request);
    }


}
